import { render, staticRenderFns } from "./PrivacyPolicies.vue?vue&type=template&id=41f2c07a&scoped=true&"
import script from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicies.vue?vue&type=style&index=0&id=41f2c07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2c07a",
  null
  
)

export default component.exports